import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'sirius-rating-item',
    templateUrl: './rating-item.component.html',
    styleUrl: './rating-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'sir-rating-item',
    },
})
export class RatingItemComponent {
    readonly label = input('');
    readonly value = input.required<number>();
    readonly max = input(5);

    protected readonly clampedMax = computed(() => Math.max(0, Math.round(this.max())));
    protected readonly clampedValue = computed(() =>
        Math.max(0, Math.min(this.clampedMax(), Math.round(this.value())))
    );

    protected readonly dots = computed<boolean[]>(() =>
        Array.from({ length: this.clampedMax() }, (_, index) => index < this.clampedValue())
    );

    protected readonly ariaLabel = computed(() => {
        const summary = `${this.clampedValue()} of ${this.clampedMax()}`;
        return this.label() ? `${this.label()}: ${summary}` : summary;
    });
}
